// extracted by mini-css-extract-plugin
module.exports = {"invest-component":"invest_invest-component__1mpA8","loading":"invest_loading__2HWRa"};